exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".postItemContent[data-v-4f6d028c]{min-height:300px;font-family:Roboto,sans-serif}.postItemMetric[data-v-4f6d028c]{display:flex;justify-content:space-around;padding:20px}.postItemTitle[data-v-4f6d028c]{height:50px;padding:4px;font-family:Roboto,sans-serif;text-transform:capitalize;font-weight:700;font-size:18px}.postItemImage[data-v-4f6d028c]{height:225px}.container[data-v-4f6d028c]{display:flex;align-items:center;justify-content:center;flex-flow:column}.postItemContainer[data-v-4f6d028c]{min-height:800px;min-width:400px;border:1px solid #d3d3d3;padding:10px}@media only screen and (max-width:500px){.postItemContainer[data-v-4f6d028c]{width:100%}.postItemMetric[data-v-4f6d028c]{flex-flow:column;text-align:center;text-transform:capitalize}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f6d028c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/assets/Dynamic/app/conspiracies/dashboard.vue
// module id = 638
// module chunks = 0